import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Button } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { JsonParam, StringParam } from 'use-query-params';

import { useCurrentLabId } from 'utils/useCurrentLab';
import { encodeQueryParamsUsingSchema } from 'utils/useEncodedFilters/helpers';
import UploadStepInfoCard from './UploadStepInfoCard';

const UploadAsyncIngestHandoff = ({ studyId }: { studyId: string }) => {
  const { labId } = useCurrentLabId();
  const search = encodeQueryParamsUsingSchema(
    {
      filters: { studyId },
      labId: labId || '',
    },
    {
      filters: JsonParam,
      labId: StringParam,
    }
  );

  return (
    <UploadStepInfoCard
      icon={<UploadFileOutlinedIcon color="info" fontSize="small" />}
      tone="upload"
      title="Track slides in Uploaded Files"
      description="After transfer completes, discovery and ingest continue asynchronously. Slides may remain Queued for ingest or Ingesting before they reach Needs case assignment."
    >
      <Button
        size="small"
        variant="text"
        component={RouterLink}
        sx={{ alignSelf: 'flex-start', minWidth: 0, px: 0.75, py: 0.25 }}
        to={{ pathname: '/uploads-dashboard', search }}
      >
        Open Uploaded Files
      </Button>
    </UploadStepInfoCard>
  );
};

export default UploadAsyncIngestHandoff;
